<template>
  <section id="wisdom" class="h_51">
    <m-img src="@/v2/mobile/assets/image/h_51.jpg"></m-img>
    <img class="h_51_1" src="@/v2/mobile/assets/image/h_51_zhi.svg" />
    <div class="title_container">
      <h1 class="title">全域 AI 座舱</h1>
      <div class="secondary" v-ia>
        融合多家先进 AI
        大模型，打破智能座舱边界，以跨终端、多场景、全模态的情感感知和先进人机交互能力，打造新时代的全域
        AI 座舱
      </div>
      <div class="promotional_btn" @click="seeMoreHandle">
        观看宣传片
        <img src="@/v2/mobile/assets/image/video_play_51.svg" />
      </div>
    </div>
    <transition>
      <div class="video_mask" v-if="moreVisible" @click.self="closeMask">
        <div class="close_btn">
          <span
            class="btn btn1"
            @click="closeMask"
            bg-url="@/auto/assets/image/1/default.png"
            v-bg
          ></span>
          <span
            class="btn btn2"
            @click="closeMask"
            bg-url="@/auto/assets/image/1/hover.png"
            v-bg
          ></span>
        </div>

        <m-video
          class="mask_video"
          disablepictureinpicture
          poster="@/v2/mobile/assets/video/poster/v_50.webp"
          src="@/v2/auto/assets/video/50/0.mp4"
          controlslist="nodownload"
          width="70%"
          autoplay
          controls
          ref="mask_video"
        ></m-video>
      </div>
    </transition>
  </section>
</template>

<script>
import VideoPlay from '@/v2/auto/assets/image/0/video_play.vue'
export default {
  name: 'h_50',
  components: {
    VideoPlay,
  },
  data() {
    return {
      preload_: true,
      moreVisible: false,
    }
  },
  methods: {
    seeMoreHandle() {
      this.moreVisible = true
      document.body.style = 'overflow: hidden;'
    },
    closeMask() {
      const video = this.$refs.mask_video
      video.pause()
      this.moreVisible = false
      document.body.style = 'overflow: inhert;'
    },
  },
}
</script>
<style lang="less" scoped>
.h_51 {
  position: relative;
  margin-top: -5px;
  .h_51_1 {
    position: absolute;
    top: 23%;
    left: 50%;
    width: 88px;
    height: 88px;
    transform: translate(-50%, -50%);
  }
}
.title_container {
  position: absolute;
  width: 70%;
  top: 75%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;

  h1 {
    font-size: 34px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .secondary {
    font-size: 16px;
    margin-bottom: 30px;
    line-height: 1.5;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    color: #ffffff80;
  }
}
.promotional_btn {
  position: absolute;
  left: 50%;
  top: 120%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  font-size: 18px;
  color: #ffffff;
  width: 164px;
  height: 48px;
  border-radius: 100px;
  background-color: #ffffff33;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 0;

  img {
    width: 20px;
    height: 20px;
  }
}

.video_mask {
  position: fixed;
  width: 100%;
  top: 0;
  height: 100vh;
  z-index: 100;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;

  .close_btn {
    position: absolute;
    top: 82px;
    right: 82px;
    width: 24px;
    height: 24px;
    cursor: pointer;

    &:hover {
      .btn1 {
        display: none;
      }

      .btn2 {
        display: inline-block;
      }
    }

    .btn {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      width: 100%;
      height: 100%;
      background-size: 100%;
    }

    .btn2 {
      display: none;
    }
  }

  .mask_video {
    width: 90%;
    max-width: 90vw;
    height: auto;
  }
}
</style>
